import styled from 'styled-components';
import { fontBody } from 'Styles/fonts';
import breakpoint from 'Styles/breakpoints';

export const Breadcrumbs = styled.ul`
  display: flex;
  flex-direction: row;
  list-style-type: none;
`;

export const Crumb = styled.li`
  color: var(--foreground);
  ${fontBody(14)};

  ${({ $styleQueryMode }) => breakpoint('medium', { mode: $styleQueryMode })} {
    ${fontBody(16)};
  }

  &:after {
    content: '/';
    margin-left: 3px;
    margin-right: 3px;
  }

  &:last-child {
    &:after {
      content: '';
    }
  }
`;

export const Link = styled.a`
  color: var(--foreground);
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }
`;
